var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 4.8C15.6 3.5 15 2.6 13.6 2.4C11.4 2 8 2 8 2C8 2 4.6 2 2.4 2.4C1 2.6 0.3 3.5 0.2 4.8C0 6.1 0 8 0 8C0 8 0 9.9 0.2 11.2C0.4 12.5 1 13.4 2.4 13.6C4.6 14 8 14 8 14C8 14 11.4 14 13.6 13.6C15 13.3 15.6 12.5 15.8 11.2C16 9.9 16 8 16 8C16 8 16 6.1 15.8 4.8ZM6 11V5L11 8L6 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer-youtube.f3e34e04260dd1a926a71d8dc5008047.svg";
export { ForwardRef as ReactComponent };